import { useState } from "react";

export const faqs = [
  {
    q: "What happens after I reach out?",
    a: "Jerry will personally reply by phone or email — typically within one business day — to set up a time to talk through what's going on and whether we're a good fit.",
  },
  {
    q: "Do you offer telehealth?",
    a: "Yes. Sessions are available via secure video, by phone, or in person at the office on East Second Street in Minnesota.",
  },
  {
    q: "Is this confidential?",
    a: "Absolutely. Family and custody concerns are sensitive — everything we discuss is handled with the discretion the situation requires.",
  },
  {
    q: "What does the first call cost?",
    a: "The first conversation is free. It's a chance to see if working together makes sense before any commitment.",
  },
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="reveal">
          <p className="text-xs font-medium uppercase tracking-[0.22em] text-sage-deep">
            Common questions
          </p>
          <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-balance sm:text-5xl">
            Honest answers, before you ever pick up the phone.
          </h2>
          <p className="mt-6 text-foreground/75">
            Don't see your question? Reach out below — Jerry reads every message himself.
          </p>
        </div>
        <ul className="reveal divide-y divide-border border-y border-border">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <li key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex min-h-12 w-full items-start justify-between gap-6 py-6 text-left"
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                  id={`faq-button-${i}`}
                >
                  <span className="font-display text-xl font-medium sm:text-2xl">{f.q}</span>
                  <span
                    aria-hidden
                    className={`mt-2 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border text-sage-deep transition-transform ${
                      isOpen ? "rotate-45 bg-sage-deep text-cream" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
                <div
                  id={`faq-panel-${i}`}
                  role="region"
                  aria-labelledby={`faq-button-${i}`}
                  className="grid overflow-hidden transition-all duration-500"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="min-h-0 overflow-hidden">
                    <p className="pb-6 pr-12 text-foreground/75 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
